export const TOGGLE_MODAL = '[MODAL] TOGGLE_MODAL';
export const OPEN_MODAL = '[MODAL] OPEN_MODAL';
export const CLOSE_MODAL = '[MODAL] CLOSE_MODAL';
